import { Component, OnInit, ViewChild, QueryList, ElementRef, ViewChildren, AfterViewInit, ChangeDetectorRef, ViewRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as Rx from 'rxjs';
import { Store } from '@ngrx/store';

import * as UserDataConfig from '../../../../pages/user-details/config/user-data.config';
import { Subject } from 'rxjs';
// import { FormValidationsService, QuoteDataCaptureService, ModalScroll } from '../../../../shared';

@Component({
  selector: 'app-test-ui-ct-one-component',
  templateUrl: './test-ui-ct1-component.html',
  styleUrls: ['./test-ui-ct1-component.scss']
})
export class TestUIControlTypeOneComponent implements OnInit {
  id = 0;
  protected userInputDetail = UserDataConfig.ElementsConfig;
  public accordianData = [];
  healthData: any;
  testUICtOneForm: UntypedFormGroup;
  // tslint:disable-next-line:max-line-length
  public checkBoxConfig = [{ key: 0, value: 'Angular', isChecked: true }, { key: 1, value: 'JAVA' }, { key: 2, value: 'Node JS' }, { key: 3, value: 'React' }];
  // tslint:disable-next-line:max-line-length
  public checkboxSubquestionConfig = [{ key: 20, value: 'Heart Disease', isChecked: false }, { key: 21, value: 'Retinopathy (Excluding Other Eye Disease)' }, { key: 22, value: 'Neuropathy' }, { key: 23, value: 'Kidney Disease (Protein in Urine)' }];
  // tslint:disable-next-line:max-line-length
  //public radioButtonConfig = [{key: 10, value: 'Angular', isChecked: true}, {key: 11, value: 'JAVA'}, {key: 12, value: 'Node JS'}, {key: 13, value: 'React'}];

  // tslint:disable-next-line:max-line-length
  public searchDataConfig = [{ key: 0, value: 'London' }, { key: 1, value: 'Bengaluru' }, { key: 2, value: 'Mumbai' }, { key: 3, value: 'Chennai' }, { key: 3, value: 'Kolkata' }];

  public tabSquareConfig = [{ id: 0, name: 'Medication', selected: true }];
  public label: string = 'Current Medication';



  constructor(private activatedRoute: ActivatedRoute, private fb: UntypedFormBuilder) {

  }

  ngOnInit() {

    // this.healthData = this.activatedRoute.snapshot.data.contentData.healthandlifestyle;
    // this.testUICtOneForm = this.fb.group({
    //   medName: [null],
    //   test1: [null, Validators.required]

    // });
  }





}
